import React from "react";
import { Link } from "react-router-dom";

export default function About({ onLoginRequest }) {
  return (
    <section style={{ maxWidth: 820 }}>
      <h1 className="section-title">О нас</h1>
      <p style={{ color: "#4a4a68", marginTop: -8, marginBottom: 24, fontSize: "1.03rem", lineHeight: 1.6 }}>
        «Современный Врач» — научно-образовательная платформа для практикующих медицинских специалистов:
        клинические рекомендации Минздрава и справочник лекарств в один клик, ИИ-поиск, который отвечает
        только на основе проверяемых источников, и профессиональное сообщество, где видно, кто и что
        реально публикует.
      </p>

      <nav
        style={{
          display: "flex", flexWrap: "wrap", gap: "6px 18px",
          padding: "12px 16px", background: "#f7f8fc", border: "1px solid #e2e4f0",
          borderRadius: 10, marginBottom: 28, fontSize: "0.88rem",
        }}
      >
        <a href="#content">Научная база</a>
        <a href="#ai">ИИ-поиск</a>
        <a href="#community">Сообщество</a>
        <a href="#tools">Инструменты</a>
        <a href="#trust">Доверие и данные</a>
        <a href="#start">Как начать</a>
      </nav>

      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginBottom: 24 }}>
        <Link to="/editors" className="main-nav-link" style={{ border: "1px solid var(--gray-300)" }}>Редакция портала</Link>
        <Link to="/manufacturers" className="main-nav-link" style={{ border: "1px solid var(--gray-300)" }}>Партнёры и производители</Link>
        <Link to="/help" className="main-nav-link" style={{ border: "1px solid var(--gray-300)" }}>Помощь</Link>
      </div>

      <div className="article-body">
        <h3 id="content">Научная база</h3>
        <p><strong>Клинические рекомендации Минздрава.</strong> Полный текст более 700 документов,
          разбитый на тысячи фрагментов для точного поиска: это не просто список PDF, а материал,
          по которому действительно можно искать. Оригиналы не хранятся на портале, только текст и ссылка на официальный
          реестр cr.minzdrav.gov.ru.</p>
        <p><strong>Справочник лекарств.</strong> Живой поиск по МНН или торговому названию прямо
          в Государственном реестре лекарственных средств (ГРЛС) — официальный текст инструкции,
          без пересказа ИИ. Для дозировок и противопоказаний важна дословность.</p>
        <p><strong>Статьи, лекции и клинические случаи.</strong> С фильтром по специальности, аудиоверсией
          статей и интерактивным разбором случаев — пошаговым квизом с обратной связью, а не просто
          текстом для чтения.</p>

        <h3 id="ai">ИИ-поиск без выдумывания фактов</h3>
        <p>Ответ формируется ИИ только по материалам, реально найденным на портале и в базе
          клинических рекомендаций, — с обязательными ссылками на источники прямо в тексте ответа.
          Если подходящих материалов нет, об этом так и сказано, без правдоподобной, но неверной догадки.</p>
        <p>Раз в неделю — короткий ИИ-дайджест новых материалов по вашей специальности, на почту и в приложении.</p>

        <h3 id="community">Сообщество и репутация</h3>
        <p><strong>Редакция портала.</strong> За каждым разделом закреплён конкретный практикующий
          врач — ответственный редактор, который отбирает материалы под своим именем, а не безликий алгоритм.
          Раздел без редактора честно помечен вакансией. Смотрите <Link to="/editors">полный список
          редакторов</Link>.</p>
        <p><strong>Профиль-визитка.</strong> У каждого врача — публичная страница с фото, специализацией
          и статистикой: не только просмотры и реакции, но и то, сколько раз материал стал источником
          ответа ИИ-поиска.</p>
        <p><strong>Справочник коллег.</strong> Поиск врача по специальности — чтобы быстро найти, кому
          передать пациента или с кем обсудить сложный случай.</p>
        <p><strong>Второе мнение.</strong> Загрузка исходной записи ЭКГ, холтеровского мониторирования или СМАД —
          эксперт даёт письменное заключение или разбирает случай на онлайн-сессии.</p>
        <p><strong>Обсуждения.</strong> Каналы по специальностям с чатом в реальном времени: файлы,
          голосовые сообщения, реакции, опросы.</p>

        <h3 id="tools">Инструменты у постели больного</h3>
        <p>Семь встроенных калькуляторов и шкал риска — ИМТ, СКФ (CKD-EPI 2021), CHA₂DS₂-VASc,
          HAS-BLED, Wells (ТЭЛА), CURB-65, TIMI (НС/ИМбпST) — и ссылка на калькулятор GRACE.
          Также доступна анонимизация PDF-документов.</p>

        <h3 id="trust">Доверие и защита данных</h3>
        <p>Мы берём явное согласие на обработку персональных данных при регистрации (152-ФЗ);
          документы верификации врача хранятся отдельно от публичных файлов. Используются российские
          ИИ-сервисы — без гео-блокировок и без утечки данных за пределы РФ. Сайт работает на
          собственном домене, резервные копии базы данных создаются регулярно.</p>

        <h3 id="start">Как начать</h3>
        <p>Зарегистрируйтесь, укажите специальность и пройдите верификацию (загрузите диплом или
          сертификат): после проверки администратором в вашем профиле появится бейдж «Подтверждённый
          врач». Он нужен, чтобы публиковать материалы и отправлять записи на второе мнение.</p>
        <p style={{ marginTop: 18 }}>
          {onLoginRequest ? (
            <button onClick={onLoginRequest} style={{
              background: "#e5005b", color: "#fff", border: "none", borderRadius: 8,
              padding: "10px 22px", fontWeight: 700, fontSize: "0.95rem", cursor: "pointer",
            }}>
              Зарегистрироваться
            </button>
          ) : (
            <Link to="/">На главную</Link>
          )}
        </p>

        <blockquote>
          Не нашли ответа? Напишите на <a href="mailto:info@svrach.ru">info@svrach.ru</a>
          или загляните в <Link to="/help">полную справку по платформе</Link>.
        </blockquote>

        <p style={{ color: "var(--gray-500)", fontSize: "0.9rem", marginTop: 24 }}>
          Дизайн портала: <a href="https://vk.ru/designmirosha" target="_blank" rel="noopener noreferrer">Елена Миронова</a>.
        </p>
      </div>
    </section>
  );
}
